<template>
<div>
    <v-alert v-if="display" dense :type="type">
        <div>{{ message }}</div>
        <div v-if="(errors && Object.keys(errors).length)">
            <div v-for="(error, key) in errors" :key="`alert-error-${key}`">{{ error[0] }}</div>
        </div>
    </v-alert>
</div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'Alert',
  computed: {
    ...get('alert', [
      'display',
      'type',
      'message',
      'errors'
    ])
  }
}
</script>
